import type { ShareableType } from '@bindoc-projects/resource-domain-lib';
import type { Cloneable, OverrideProperty } from '@bindoc-projects/util-domain-lib';
import type { VirtualClinicAnalysisOperatingNumberTermType } from './term-type';
import type { VirtualClinicAnalysisFullyInpatientCasesFilter } from '../filter/fully-inpatient-cases';
import type { VirtualClinicAnalysisOperatingNumberTermSpec } from '../../resolving';

export abstract class VirtualClinicAnalysisOperatingNumberTerm
  implements Cloneable<VirtualClinicAnalysisOperatingNumberTerm>
{
  protected constructor(
    public readonly type: VirtualClinicAnalysisOperatingNumberTermType,
  ) {}

  public abstract clone(): VirtualClinicAnalysisOperatingNumberTerm;

  public abstract getFullyInpatientCasesFilters(): VirtualClinicAnalysisFullyInpatientCasesFilter[];

  public abstract overrideClone(
    override: OverrideProperty[],
  ): VirtualClinicAnalysisOperatingNumberTerm;

  public abstract getChildResources(): {
    [resourceName in ShareableType]?: string[];
  };

  public abstract toJSON(): VirtualClinicAnalysisOperatingNumberTermSpec;

  public abstract getOverrideProperties(
    tileId: string,
    dependencyVirtualClinicId: string,
  ): OverrideProperty[];

  public abstract isValid(): boolean;

  public abstract onUpdateVirtualClinicId(virtualClinicId: string): void;
}
